import React, { useState } from "react";
import { _t } from "../../utils/i18nUtils";
import { isObject, isSet} from "../../utils/commonUtils";
import {
  useNavigate,
  Link,
} from "react-router-dom";
import AuthService from "../../services/AuthService";
import FormInputs from "../../components/UI/FormInputs";
import Card from "../../components/UI/Card";
import UserService from "../../services/UserService";
import { useDispatch } from 'react-redux';
import {setProfileDetails,setProfileStateList} from '../../store/SessionSlice';
import WithRoutify from '../../hoc/WithRoutify';
import Buttons from "../../components/UI/Buttons";
import OrganizationService from "../../services/OrganizationService";
import { setSessionIsActive } from "../../store/CommonSlice";
import i18n from "../../i18n/config";
import WithRouter from "../../hoc/WithRouter";
import { acl_check } from "../../utils/aclUtils";

const LoginForm = (props) => {
  const {Loader}=props
  const [validation,setValidation] = useState("");
  // const query= new URLSearchParams(useLocation().search);
  const [formdata,setFormData]=useState({
    'email':'',
    'password':'',
  });
  const [formValidation,setFormValidation] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();  
  //onchange event
  const handleOnChange=(value,{e})=>{
    setFormData({...formdata,[e.target.name]:value});
    setFormValidation({...setFormValidation,[e.target.name]:''})
    setValidation('');
  }
//login
  const handleLogin = async () => {
    // console.group("Login");
    const {email,password}=formdata;
    const credentials = {email,password};
    
    Loader(true);
    try{
      const userData    = await AuthService.login(credentials);
      let updateValidation = {};
      if(userData.status && userData.status==='ERROR'){
        Loader(false);
        if (isObject(userData.data)) {
          for (let key in userData.data) {
            updateValidation = {
              ...updateValidation,
              [key]: userData.data[key]
            };
          }
          if (Object.keys(updateValidation).length > 0) {
            setFormValidation(updateValidation);
          }
        } 
        if (userData.data.error) {
            setValidation(isSet(userData.data.error,'Authentication failed')+'  The information you have provided cannot be authenticated. Check your login information and try again');
  
        }
       return; 
      }
      // if (userData?.twoFactorRequired) {
      //   Loader(false);
      //   navigate('/two-factor-authentication', {
      //     state: { email: formdata.email, password:formdata.password }
      //   });
      //   return;
      // }
      const isAuthenticated = AuthService.isAuthenticated();
      if (isAuthenticated === true) {
        dispatch(setSessionIsActive(true));
        const profileData = await UserService.getUserProfile();
        if(isSet(profileData.organization_id,null)!==null){
          OrganizationService.storeOrgId(profileData.organization_id);
          OrganizationService.storeTimeZone(profileData.organization_id);
        }
        i18n.changeLanguage(profileData.preferred_language);
        AuthService.storePrefLanguage(profileData.preferred_language);
        AuthService.store2FAverifed(profileData.two_factor_verified);
        // console.log('profileData',profileData.preferred_language);
        // if(isSet(profileData) && !isSet(profileData.role[0])){
        //   Employeeervice.storeEmployeeId(profileData.employee_id);
        // }
        // console.log('profileData',profileData);
        AuthService.storeProfileId(profileData.id);
        dispatch(setProfileDetails({ key: profileData.id, value:profileData }));
        Loader(false);
        let stateListResponse=await UserService.getUserStateList();
        let states=[{label:'-Select State-',value:''}];
        stateListResponse&&stateListResponse.forEach((val)=>{
          states.push({label:val.code,value:val.code})
        });
        // if(profileData.two_factor_verified==false){
        //   console.log('two_factor_verified',profileData.two_factor_verified);
        //   console.log('two_factor_method',profileData.two_factor_list);
        //   navigate('/two-factor-authentication', {
        //     state: { email: formdata.email, password:formdata.password, two_factor_list: profileData.two_factor_list}
        //   });
        //   return;
        // }
        const {permissions,is_multiple_organization,role,employer_login} = profileData;
        let redirectUrl = '/dashboard';
        // Check for employer admin first - redirect to dashboard
        if(role === 'employer_admin' || employer_login === true){
          redirectUrl = '/dashboard';
        }
        else if(isSet(is_multiple_organization,false)===true && acl_check(permissions,'organization-list')===true){
          redirectUrl = '/organisation';
        }
        else if(acl_check(permissions,'dashboard-list')===true){
          redirectUrl = '/dashboard';
        }
        else if(acl_check(permissions,'appointment-list')===true){
          redirectUrl = '/appointments';
      }
 else if(acl_check(permissions,'company-list')===true){
            redirectUrl = '/company';
        }else if(acl_check(permissions,'activities-list')===true){
            redirectUrl = '/activities';
        }else if(acl_check(permissions,'ai-diagnosis-logs-list')===true){
            redirectUrl = '/ai-diagnosis-logs';
        }else if(acl_check(permissions,'audit-log-list')===true){
            redirectUrl = '/audit-log';
        }else if(acl_check(permissions,'basic-physical-list')===true){
            redirectUrl = '/basic-physical';
        }else if(acl_check(permissions,'clinic-department-list')===true){
          redirectUrl = '/clincs-department';
        }else if(acl_check(permissions,'company-division-list')===true){
          redirectUrl = '/division';
        }else if(acl_check(permissions,'compliance-monitor-list')===true){
          redirectUrl = '/compliance-monitor';
        }else if(acl_check(permissions,'consent-list')===true){
          redirectUrl = '/intake-paperwork';
        }else if(acl_check(permissions,'contract-list')===true){
          redirectUrl = '/contract/pricing';
        }else if(acl_check(permissions,'cpt-list')===true){
          redirectUrl = '/cpt-code';
        }else if(acl_check(permissions,'csv-import-list')===true){
          redirectUrl = '/csv-import';
        }else if(acl_check(permissions,'dot-submission-logs-list')===true){
          redirectUrl = '/dot-submission-logs';
        }else if(acl_check(permissions,'emr-configuration-list')===true){
          redirectUrl = '/emr';
        }else if(acl_check(permissions,'failed-ez-reader-list')===true){
          redirectUrl = '/failed-ez-reader';
        }else if(acl_check(permissions,'hl7-log-list')===true){
          redirectUrl = '/hl7/log';
        }else if(acl_check(permissions,'icd10-list')===true){
          redirectUrl = '/icd10-code';
        }else if(acl_check(permissions,'incident-list')===true){
          redirectUrl = '/incident';
        }else if(acl_check(permissions,'lab-list')===true){
          redirectUrl = '/laboratory';
        }else if(acl_check(permissions,'insurance-list')===true){
          redirectUrl = '/insurance';
        }else if(acl_check(permissions,'work-comp-insurance-list')===true){
          const isMultiOrg = isSet(is_multiple_organization, false) === true;
          if (isMultiOrg || role === 'global_admin') {
            redirectUrl = '/workcomp-insurance';
          }
        }else if(acl_check(permissions,'sftp-configuration-list')===true){
          const isMultiOrg = isSet(is_multiple_organization, false) === true;
          if (isMultiOrg || role === 'global_admin') {
          redirectUrl = '/configure';
          }
        }else if(acl_check(permissions,'tutorial-video-list')===true){
          const isMultiOrg = isSet(is_multiple_organization, false) === true;
          if (isMultiOrg || role === 'global_admin') {
            redirectUrl = '/video-configure';
          }
        }else if(acl_check(permissions,'clearing-house-list')===true){
          const isMultiOrg = isSet(is_multiple_organization, false) === true;
          if (isMultiOrg || role === 'global_admin') {
            redirectUrl = '/clearing-house';
          }
        }else if(acl_check(permissions,'lab-panel-list')===true){
          redirectUrl = '/lab-pannel-configuration';
        }else if(acl_check(permissions,'lookup-list')===true){
          redirectUrl = '/lookup';
        }else if(acl_check(permissions,'merge-patient-list')===true){
          redirectUrl = '/merge-history';
        }else if(acl_check(permissions,'notification-log-list')===true){
          redirectUrl = '/notification-log';
        }else if(acl_check(permissions,'notification-template-list')===true){
          redirectUrl = '/notification-template';
        }else if(acl_check(permissions,'provider-list')===true){
          redirectUrl = '/providers';
        }else if(acl_check(permissions,'random-generator-list')===true){
          redirectUrl = '/random-generator';
        }else if(acl_check(permissions,'referral-provider-list')===true){
          redirectUrl = '/referral-providers';
        }else if(acl_check(permissions,'reports-list')===true){
          redirectUrl = '/reports';
        }else if(acl_check(permissions,'state-form-list')===true){
          redirectUrl = '/forms-configuration';
        }else if(acl_check(permissions,'vaccine-administration-list')===true){
          redirectUrl = '/vaccine-administration';
        }else if(acl_check(permissions,'clinic-list')===true){
            redirectUrl = '/clinics';
        }else if(acl_check(permissions,'employee-list')===true){
            redirectUrl = '/employee';
        }else if(acl_check(permissions,'visits-list')===true){
            redirectUrl = '/visits';
        }else if(acl_check(permissions,'white-board-list')===true){
          redirectUrl = '/white-board';
        }else if(acl_check(permissions,'user-list')===true){
            redirectUrl = '/users';
        }else if(acl_check(permissions,'role-list')===true){
            redirectUrl = '/roles';
        }
        dispatch(setProfileStateList(states));
        const redirectPath = props.location.pathname.includes('send-questionnaire') ? `/result/physical-drug-screens${props.location.search}` : redirectUrl;
        navigate(redirectPath);        
      }
    }catch(e){
      // showToast('error',"An error occurred");
      Loader();
    }
    
    
    //api/user_profile
    // console.log("Logging in with:", userData, AuthService.getToken());
  };
  
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      // event.preventDefault();
      handleLogin();
    }
  };

  // useEffect(() => {
  //   const keyDownHandler = event => {
  //     if (event.key === 'Enter') {
  //       event.preventDefault();
  //       handleLogin();
  //     }
  //   };
  //   //handle to Enter-key press in form
  //   document.addEventListener('keydown', keyDownHandler);
  //   return () => {
  //     document.removeEventListener('keydown', keyDownHandler);
  //   };
  // }, [formdata]);

  const handleEmailChange = (e) => {
    const next = e.target.value;
    setFormData((prev) => ({ ...prev, email: next }));
    setFormValidation((prev) => ({ ...prev, email: '' }));
    setValidation('');
  };

  const handlePasswordChange = (e) => {
    const next = e.target.value;
    setFormData((prev) => ({ ...prev, password: next }));
    setFormValidation((prev) => ({ ...prev, password: '' }));
    setValidation('');
  };

  return (
    <div className="sh_login">
      <div className="sh_login-bleed">
        <main className="sh_login-bg">
        <div className="container sh_login-container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="sh_login-hero text-center">
                <div className="sh_login-brand">SnapEHR</div>
                <div className="sh_login-title">A New Generation Has Arrived</div>
                <div className="sh_login-subtitle">
                  Healthcare technology finally built for the way modern medicine works.
                </div>
              </div>

              <div className="d-flex justify-content-center">
                <div className="sh_login-card">
                  <div className="sh_login-card-inner">
                    <div className="sh_login-card-title">Welcome back!</div>
                    <div className="sh_login-card-subtitle">
                      Sign in to your account to continue
                    </div>

                    {isSet(validation, '') !== '' ? (
                      <p className="text-danger m-1" style={{ fontSize: '12px' }}>
                        {isSet(validation, '')}
                      </p>
                    ) : null}

                    <form
                      className="mt-3"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleLogin();
                      }}
                    >
                      <div className="mb-3">
                        <div className="sh_login-input">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              x="2"
                              y="3"
                              width="12"
                              height="10"
                              rx="2"
                              stroke="#4A505C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M4.66602 5.98926L7.4691 7.21142C7.80763 7.35902 8.19222 7.3596 8.53119 7.21302L11.3327 6.00167"
                              stroke="#4A505C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <input
                            id="loginEmail"
                            type="email"
                            className="form-control sh_login-control"
                            placeholder={_t('emailAddress')}
                            value={formdata.email}
                            name="email"
                            onChange={handleEmailChange}
                            onKeyDown={handleKeyPress}
                            autoComplete="username"
                          />
                        </div>
                        {formValidation?.email ? (
                          <span className="text-danger m-1">{formValidation.email}</span>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <div className="sh_login-input">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.33398 6.66667V4.66667V4.66667C5.33398 3.194 6.52798 2 8.00065 2V2C9.47332 2 10.6673 3.194 10.6673 4.66667V4.66667V6.66667"
                              stroke="#4A505C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M11.334 14.0001H4.66732C3.93065 14.0001 3.33398 13.4034 3.33398 12.6667V8.00008C3.33398 7.26341 3.93065 6.66675 4.66732 6.66675H11.334C12.0707 6.66675 12.6673 7.26341 12.6673 8.00008V12.6667C12.6673 13.4034 12.0707 14.0001 11.334 14.0001Z"
                              stroke="#4A505C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M5.99935 10.3608C5.99735 10.3608 5.99602 10.3621 5.99602 10.3641C5.99602 10.3661 5.99735 10.3674 5.99935 10.3674C6.00135 10.3674 6.00268 10.3661 6.00268 10.3641C6.00268 10.3621 6.00135 10.3608 5.99935 10.3608"
                              stroke="#4A505C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M8.00326 10.3608C8.00126 10.3608 7.99992 10.3621 7.99992 10.3641C7.99992 10.3661 8.00192 10.3674 8.00326 10.3674C8.00526 10.3674 8.00659 10.3661 8.00659 10.3641C8.00659 10.3621 8.00526 10.3608 8.00326 10.3608"
                              stroke="#4A505C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M9.99935 10.3608C9.99735 10.3608 9.99602 10.3621 9.99602 10.3641C9.99602 10.3661 9.99735 10.3674 9.99935 10.3674C10.0013 10.3674 10.0027 10.3661 10.0027 10.3641C10.0027 10.3621 10.0013 10.3608 9.99935 10.3608"
                              stroke="#4A505C"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <input
                            id="loginPassword"
                            type={showPassword ? 'text' : 'password'}
                            className="form-control sh_login-control"
                            placeholder={_t('password')}
                            value={formdata.password}
                            name="password"
                            onChange={handlePasswordChange}
                            onKeyDown={handleKeyPress}
                            autoComplete="current-password"
                          />
                          <button
                            className="btn sh_login-eye"
                            type="button"
                            aria-label="Show password"
                            onClick={() => setShowPassword((v) => !v)}
                          >
                            <i
                              className={showPassword ? 'far fa-eye fourth_light_color' : 'far fa-eye-slash fourth_light_color'}
                              style={{ fontSize: '15px' }}
                            />
                          </button>
                        </div>
                        {formValidation?.password ? (
                          <span className="text-danger m-1">{formValidation.password}</span>
                        ) : null}
                      </div>

                      <div className="d-flex align-items-center justify-content-end mt-2 mb-3">
                        <a
                          className="sh_login-link"
                          href="/login/forgetPassword"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate('/login/forgetPassword');
                          }}
                        >
                          Forgot Password?
                        </a>
                      </div>

                      <button type="submit" className="btn sh_login-btn w-100">
                        Sign in
                      </button>

                      <div className="sh_login-register mt-2 text-center">
                        <a
                          href="javascript:void(0)"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate('/self-register');
                          }}
                        >
                          Register now!
                        </a>
                      </div>

                      <div className="sh_login-legal text-center my-3">
                        By logging in you confirm that you accept the
                        <Link className="sh_login-link" target="_blank" to="/terms-of-use">
                          Terms and Conditions
                        </Link>{' '}
                        and{' '}
                        <Link className="sh_login-link" target="_blank" to="/privacy-policy">
                          Privacy Policy
                        </Link>
                        .
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </main>
      </div>
    </div>
  );
};

export default WithRouter(WithRoutify(LoginForm));
